// Sətirləri hissə-hissə (chunk) serverə göndər və faiz irəliləyişi bildir.
// postChunk(rows) → axios cavabı (data.ok + created/updated/added/skipped və s.). Rəqəm sahələri toplanır.
const SUM_FIELDS = ['created', 'updated', 'added', 'skipped'];
export async function chunkedImport(rows, postChunk, onProgress, chunkSize = 100) {
  const total = rows.length;
  const acc = { created: 0, updated: 0, added: 0, skipped: 0 };
  let done = 0;
  onProgress && onProgress(0, total);
  for (let i = 0; i < total; i += chunkSize) {
    const part = rows.slice(i, i + chunkSize);
    const { data } = await postChunk(part);
    if (!data || !data.ok) return { ok: false, msg: (data && data.msg) || 'İmport alınmadı', ...acc };
    for (const f of SUM_FIELDS) acc[f] += (parseInt(data[f]) || 0);
    // Əlavə saylar (ödəniş, yeni alıcı, tapılmayan mal...) da toplanır
    for (const [k, v] of Object.entries(data)) if (!SUM_FIELDS.includes(k) && typeof v === 'number') acc[k] = (acc[k] || 0) + v;
    done += part.length;
    onProgress && onProgress(Math.round(done / total * 100), total, done);
  }
  return { ok: true, ...acc };
}
